/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CancelConversationRunInput } from '../models/cancel-conversation-run-input';
import { ConversationMessageResult } from '../models/conversation-message-result';
import { ConversationSummaryResult } from '../models/conversation-summary-result';
import { CreateConversationResult } from '../models/create-conversation-result';
import { RunAgentInput } from '../models/run-agent-input';
import { UploadAgentFileResult } from '../models/upload-agent-file-result';

@Injectable({
  providedIn: 'root',
})
export class AgentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation uploadAgentFile
   */
  static readonly UploadAgentFilePath = '/api/v1/Agent/files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadAgentFile$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAgentFile$Plain$Response(params?: {
    body?: {
'file'?: Blob;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UploadAgentFileResult>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.UploadAgentFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UploadAgentFileResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadAgentFile$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAgentFile$Plain(params?: {
    body?: {
'file'?: Blob;
}
  },
  context?: HttpContext

): Observable<UploadAgentFileResult> {

    return this.uploadAgentFile$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<UploadAgentFileResult>) => r.body as UploadAgentFileResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadAgentFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAgentFile$Response(params?: {
    body?: {
'file'?: Blob;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UploadAgentFileResult>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.UploadAgentFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UploadAgentFileResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadAgentFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAgentFile(params?: {
    body?: {
'file'?: Blob;
}
  },
  context?: HttpContext

): Observable<UploadAgentFileResult> {

    return this.uploadAgentFile$Response(params,context).pipe(
      map((r: StrictHttpResponse<UploadAgentFileResult>) => r.body as UploadAgentFileResult)
    );
  }

  /**
   * Path part for operation listAgentConversations
   */
  static readonly ListAgentConversationsPath = '/api/v1/Agent/conversations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAgentConversations$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAgentConversations$Plain$Response(params?: {
    limit?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ConversationSummaryResult>>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.ListAgentConversationsPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConversationSummaryResult>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAgentConversations$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAgentConversations$Plain(params?: {
    limit?: number;
  },
  context?: HttpContext

): Observable<Array<ConversationSummaryResult>> {

    return this.listAgentConversations$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ConversationSummaryResult>>) => r.body as Array<ConversationSummaryResult>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAgentConversations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAgentConversations$Response(params?: {
    limit?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ConversationSummaryResult>>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.ListAgentConversationsPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConversationSummaryResult>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAgentConversations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAgentConversations(params?: {
    limit?: number;
  },
  context?: HttpContext

): Observable<Array<ConversationSummaryResult>> {

    return this.listAgentConversations$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ConversationSummaryResult>>) => r.body as Array<ConversationSummaryResult>)
    );
  }

  /**
   * Path part for operation createAgentConversation
   */
  static readonly CreateAgentConversationPath = '/api/v1/Agent/conversations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAgentConversation$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  createAgentConversation$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CreateConversationResult>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.CreateAgentConversationPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateConversationResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAgentConversation$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createAgentConversation$Plain(params?: {
  },
  context?: HttpContext

): Observable<CreateConversationResult> {

    return this.createAgentConversation$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<CreateConversationResult>) => r.body as CreateConversationResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAgentConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  createAgentConversation$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CreateConversationResult>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.CreateAgentConversationPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateConversationResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAgentConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createAgentConversation(params?: {
  },
  context?: HttpContext

): Observable<CreateConversationResult> {

    return this.createAgentConversation$Response(params,context).pipe(
      map((r: StrictHttpResponse<CreateConversationResult>) => r.body as CreateConversationResult)
    );
  }

  /**
   * Path part for operation cancelAgentConversationRun
   */
  static readonly CancelAgentConversationRunPath = '/api/v1/Agent/conversations/{conversationId}/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelAgentConversationRun()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cancelAgentConversationRun$Response(params: {
    conversationId: string;
    body?: CancelConversationRunInput
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.CancelAgentConversationRunPath, 'post');
    if (params) {
      rb.path('conversationId', params.conversationId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelAgentConversationRun$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cancelAgentConversationRun(params: {
    conversationId: string;
    body?: CancelConversationRunInput
  },
  context?: HttpContext

): Observable<void> {

    return this.cancelAgentConversationRun$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteAgentConversation
   */
  static readonly DeleteAgentConversationPath = '/api/v1/Agent/conversations/{conversationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAgentConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAgentConversation$Response(params: {
    conversationId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.DeleteAgentConversationPath, 'delete');
    if (params) {
      rb.path('conversationId', params.conversationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAgentConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAgentConversation(params: {
    conversationId: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteAgentConversation$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getAgentConversationMessages
   */
  static readonly GetAgentConversationMessagesPath = '/api/v1/Agent/conversations/{conversationId}/messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgentConversationMessages$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentConversationMessages$Plain$Response(params: {
    conversationId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ConversationMessageResult>>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.GetAgentConversationMessagesPath, 'get');
    if (params) {
      rb.path('conversationId', params.conversationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConversationMessageResult>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgentConversationMessages$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentConversationMessages$Plain(params: {
    conversationId: string;
  },
  context?: HttpContext

): Observable<Array<ConversationMessageResult>> {

    return this.getAgentConversationMessages$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ConversationMessageResult>>) => r.body as Array<ConversationMessageResult>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgentConversationMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentConversationMessages$Response(params: {
    conversationId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ConversationMessageResult>>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.GetAgentConversationMessagesPath, 'get');
    if (params) {
      rb.path('conversationId', params.conversationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConversationMessageResult>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgentConversationMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentConversationMessages(params: {
    conversationId: string;
  },
  context?: HttpContext

): Observable<Array<ConversationMessageResult>> {

    return this.getAgentConversationMessages$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ConversationMessageResult>>) => r.body as Array<ConversationMessageResult>)
    );
  }

  /**
   * Path part for operation downloadAgentFile
   */
  static readonly DownloadAgentFilePath = '/api/v1/Agent/files/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadAgentFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadAgentFile$Response(params: {
    fileId: string;
    containerId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.DownloadAgentFilePath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
      rb.query('containerId', params.containerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadAgentFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadAgentFile(params: {
    fileId: string;
    containerId?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.downloadAgentFile$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation runAgent
   */
  static readonly RunAgentPath = '/api/v1/Agent/run';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runAgent()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  runAgent$Response(params?: {
    body?: RunAgentInput
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AgentService.RunAgentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `runAgent$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  runAgent(params?: {
    body?: RunAgentInput
  },
  context?: HttpContext

): Observable<void> {

    return this.runAgent$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
